import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "roulette-skin" }
const _hoisted_2 = {
  key: 0,
  class: "slot-num mono"
}
const _hoisted_3 = { class: "centre-num mono" }
const _hoisted_4 = { class: "centre-sub" }
const _hoisted_5 = { class: "band-readout" }
const _hoisted_6 = { class: "band-range mono" }
const _hoisted_7 = { class: "band-pct" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["wheel", _ctx.wheelClass])
    }, [
      _createElementVNode("div", {
        class: "wheel-inner",
        style: _normalizeStyle(_ctx.wheelStyle)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.n, (i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i - 1,
            class: _normalizeClass(["slot", {
            win: _ctx.isInBand(i - 1),
            landed: _ctx.phase === 'resolved' && _ctx.roll === (i - 1),
            zero: i - 1 === 0,
          }]),
            style: _normalizeStyle(_ctx.slotStyle(i - 1))
          }, [
            (_ctx.showNumbers || (_ctx.phase === 'resolved' && _ctx.roll === (i - 1)))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(i - 1), 1))
              : _createCommentVNode("", true)
          ], 6))
        }), 128))
      ], 4),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "pointer" }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["centre", _ctx.centreClass])
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.centreText), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.centreSub), 1)
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "band-label" }, "YOU WIN ON", -1)),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.bandLabel), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.winPctLabel), 1)
    ])
  ]))
}